import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { SwiperModule } from "swiper/types";
import { useEffect, useMemo, useRef } from "react";
// import "./carousel-wrapper.styles.scss";

interface ICarsouelWrapper {
  children: JSX.Element[];
  swiperModules: SwiperModule[];
  delay?: number;
  disableNavigation?: boolean;
  otherConfigs?: { [key: string]: any };
  disableLoop?: boolean;
  activeSlideIndex?: number;
  setAcitiveSlideIndex?: (index: number) => void;
  disableAutoPlay?: boolean;
}

const CarouselWrapper = ({
  children,
  swiperModules,
  disableNavigation,
  delay,
  otherConfigs,
  disableLoop,
  activeSlideIndex,
  setAcitiveSlideIndex,
  disableAutoPlay,
}: ICarsouelWrapper) => {
  const swiper = useRef<any>(null);
  const slideTo = (index: number) => swiper.current.slideTo(index);

  useEffect(() => {
    if (activeSlideIndex !== undefined) {
      slideTo(activeSlideIndex);
    }
  }, [activeSlideIndex]);

  useEffect(() => {
    let swiperEl = document.querySelector('.swiper');
    if (!swiperEl) return;

    const observer = new IntersectionObserver((entries, observer) => {
      if (entries[0].isIntersecting) {
        swiper.current.autoplay.start();
      } else {
        swiper.current.autoplay.stop();
      }
    });
    observer.observe(swiperEl);

    return () => observer.disconnect()
  }, []);

  return (
    <Swiper
      navigation={disableNavigation ? false : true}
      loop={disableLoop ? false : true}
      modules={swiperModules}
      autoplay={{
        delay: delay ?? 10000,
        disableOnInteraction: disableAutoPlay,
      }}
      className='mySwiper'
      {...otherConfigs}
      onSwiper={(s) => {
        swiper.current = s;
      }}
      onSlideChange={(e) => {
        if (setAcitiveSlideIndex !== undefined) {
          setAcitiveSlideIndex(e.activeIndex);
        }
      }}
    >
      {children.map((child, index) => (
        <SwiperSlide key={`SwiperSlide_${index}`}>{child}</SwiperSlide>
      ))}
    </Swiper>
  );
};

export default CarouselWrapper;
